export class Modal {
  constructor() {
    this.modal = $(".l-modal").first();
    if (!this.modal.length) {
      console.warn("no modal found");
      return;
    }
    this.setToggleEvents();
  }

  setToggleEvents () {
    this.modal.on("click", (e) => {
      if (e.target !== e.currentTarget) { return; }
      this.toggleShow();
    });

    $("[data-dismiss='l-modal']").on("click", () => { this.toggleShow() });
    $("[data-l-toggle='l-modal']").on("click", () => { this.toggleShow() });
  }

  toggleShow () {
    this.modal.toggleClass("is-show");
  }
}
